import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/catalogs",
    name: "Catalogs",
    component: () => import("../views/Catalogs.vue"),
  },
  {
    path: "/catalogs/:id",
    component: () => import("../views/CatalogDetail.vue"),
  },
  {
    path: "/publishers",
    component: () => import("../views/Publishers.vue"),
  },
  {
    path: "/publishers/:id",
    component: () => import("../views/PublisherDetail.vue"),
  },
  {
    path: "/shortlist",
    name: "Shortlists",
    component: () => import("../views/Shortlist.vue"),
  },
  {
    path: "/shortlist/:id/catalogs",
    name: "ShortlistCatalogs",
    component: () => import("../views/ShortlistCatalogs.vue"),
    meta: { stickyFooter: true },
  },
  {
    path: "/shortlist/:id/books",
    name: "ShortlistBooks",
    component: () => import("../views/ShortlistBooks.vue"),
    meta: { stickyFooter: true },
  },
  {
    path: "/sign-in/",
    name: "SignIn",
    component: () => import("../views/SignIn.vue"),
    meta: { layout: "LayoutAuth" },
  },
  {
    path: "/forgot-password/",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue"),
    meta: { layout: "LayoutAuth" },
  },
  {
    path: "/message-sent/",
    name: "MessageSent",
    component: () => import("../views/AuthMessageSent.vue"),
    meta: { layout: "LayoutAuth" },
  },
  {
    path: "/new-password/",
    name: "AuthNewPassword",
    component: () => import("../views/AuthNewPassword.vue"),
    meta: { layout: "LayoutAuth" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
